export default __webpack_public_path__ + "static/media/banckassurance.b0a0e4e7.png";